export class OpcionVentana {

    // Opciones para realizar una redireccion con la url tal cual este configurada en el menu
    public static REDIRECCION_DIRECTA_NUEVA_PESTANA = 'REDIRECCION_DIRECTA_NUEVA_PESTANA';
    public static AUTOS_PANAMA = 'AUTOS_PANAMA';
    public static REDIRECCION_DIRECTA = 'REDIRECCION_DIRECTA';
    public static REDIRECCION_DIRECTA_PARAMETROS = 'REDIRECCION_DIRECTA_PARAMETROS';
    public static REDIRECCION_DIRECTA_PARAMETROS_DECODIFICADOS = 'REDIRECCION_DIRECTA_PARAMETROS_DECODIFICADOS';
    // En esta opcion es para las redirecciones que se crean de manera local y se debe verificar si la
    // aplicacion esta configurada para panama
    public static REDIRECCION_DIRECTA_COTIZADOR_PA = 'REDIRECCION_DIRECTA_COTIZADOR_PA';

    // Opciones para realizar redireccion agregando el contexto de cotizador
    public static CONSULTA_REGISTRA_CLIENTE = 'CONSULTA_REGISTRA_CLIENTE';
    public static CONSULTA_REGISTRA_CLIENTE_CS = 'CONSULTA_REGISTRA_CLIENTE_CS';
    public static CONSULTA_REGISTRA_CLIENTE_CS_CT = 'CONSULTA_REGISTRA_CLIENTE_CS_CT';
    public static CONSULTAR_CLIENTE_REDIRECCION_GWT = 'CONSULTAR_CLIENTE_REDIRECCION_GWT';
    public static CONSULTAR_CLIENTE_REDIRECCION_GWT_AYV = 'CONSULTAR_CLIENTE_REDIRECCION_GWT_AYV';
    public static CONSULTAR_CLIENTE_PN_REDIRECCION_GWT = 'CONSULTAR_CLIENTE_PN_REDIRECCION_GWT';
    public static CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV = 'CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV';
    public static REDIRECION_AYV = 'REDIRECION_AYV';
    public static REDIRECCION_DIRECTA_COTIZADOR = 'REDIRECCION_DIRECTA_COTIZADOR';
    public static REDIRECCION_DIRECTA_COTIZADORES = 'REDIRECCION_DIRECTA_COTIZADORES';
    public static PUBS_COTIZADOR_CONECTADO = 'PUBS_COTIZADOR_CONECTADO';

    // Con esta opción podemos cubrir redirecciones externas con parametros codificados o decodificados, pasando por el panel de cliente
    public static CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_DECO = 'CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_DECO';
    public static CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI = 'CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI';

}



// WEBPACK FOOTER //
// ./src/app/contants/opcion-ventana.constant.ts